module.exports = __webpack_public_path__ + "img/842-bbe748.png";